import React, {ReactElement} from 'react';
import ExcelSVG from 'images/icon/ExcelIcon.svg';
import GetAppIcon from '@material-ui/icons/GetApp';
import './WebDataButton.styl';
import Tooltip from '@material-ui/core/Tooltip';

interface WebDataButtonProps {
  readonly onClick: React.EventHandler<React.MouseEvent>;
  tooltip?: ReactElement | string;
}

/**
 * A button that opens the spreadsheet viewer with data loaded via the onClick handler.
 *
 * @see WebDataRocksOverlay, which must be rendered on the page for this button to work. This is handled for you on the
 * dashboard.
 *
 * @see WebDataRocksStore, which is where the onClick handler needs to put the data.
 *
 * @param onClick click handler, typically responsible for loading the data.
 * @constructor
 */
const WebDataButton: React.FC<WebDataButtonProps> = ({onClick, tooltip}) => {
  return (
    <Tooltip title={tooltip ?? ''}>
      <div>
        <div className="spreadsheet-download-button pointer" onClick={onClick}>
          <GetAppIcon />
          <img src={ExcelSVG} alt="Excel" />
        </div>
      </div>
    </Tooltip>
  );
};

export default WebDataButton;
